import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping
} from "../../../../constants/OrderRequestReceived";

// import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import axiosInstance from "../../../services/api/API";
import { FaLessThanEqual } from "react-icons/fa";
import Loader from "../../../customComponents/CustomLoader";

const OrderReceivedRequest = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [OrderRequestReceivedData,setOrderRequestReceivedData] = useState([]);
  const [ filterFormData, setFilterFormData ] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [totalrecreq,setTotalrecreq] = useState(0)
  const [loading, setLoading] = useState(true);
  const [invoicePO,setinvoicePO] = useState(0)
  const [acceptedPO,setAcceptedPO] = useState(0)
  const [searchQuery, setSearchQuery] = useState('');

  
  const token = localStorage.getItem("authToken");
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
 const topDataList = [
    { id: 1, title: "Total Order Received Request", value: totalrecreq },
    { id: 2, title: "Total Order Accepted ", value:acceptedPO},
    { id: 3, title: "Total PO Generate invoice", value: invoicePO }];

    const filtersInputs = [
      {
        name: "search_type",
        label: "Search Type",
        placeholder:"Search Type.",
        type: "dropdown",
        options:[{value:1, label:"Order Received Request"},{value:2, label:"Order Accepted"},{value:3, label:"Generate invoice"},],
        required: true,
        gridClass: "col-lg-3",
      },
      {
        name: "startDate",
        label: "From Date",
        type: "date",
        maxDate: new Date(),
        required: false,
        gridClass: "col-lg-3",
    },
      {
          name: "endDate",
          label: "To Date",
          type: "date",
          maxDate: new Date(),
          required: false,
          gridClass: "col-lg-3",
      }
     
    ]
  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.ORDERRECIVEDREQUESTDETAILS}`, { state: { data: rowData,search_type:filterFormData?.search_type } });
  }
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPurchaseOrderList(newPage);
  };
  const handleSearch=()=>{
    if(filterFormData.search_type ){
//console.log(filterFormData,'filterFormData/////////////////')
fetchPurchaseOrderList();
    }
   
  }
  useEffect(()=>{
fetchPurchaseOrderList()
  },[])
  const apiCallFunction = () =>{
    fetchPurchaseOrderList()
  }


  const fetchPurchaseOrderList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      console.log(filterFormData.search_type,'filterFormData.search_type');
      const response = await axiosInstance.post('/poreceivedaccepted/list',{
        orderBy:"po_id asc",
        is_order_received: filterFormData.search_type===1 ||filterFormData.search_type===undefined  ?0:1,
        is_invoice_generated:filterFormData.search_type===3 ?0:null,
         formDate:filterFormData.startDate || '', //2024-05-01 date fomat
         toDate:filterFormData.endDate || "",
         page:0,
         pageSize:10,searchText:searchQuery

      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setinvoicePO(response?.data?.data?.total_po)
      setTotalrecreq(response?.data?.data?.total_recv_req)
      setAcceptedPO(response?.data?.data?.accepted_po)

    
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setOrderRequestReceivedData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
      //toastSuccess("Product Data fetched successfully!");
     
    } catch (error) {
      console.error('Error fetching product list:', error);
    }
    finally{
      setLoading(false)
    }
  };
  useEffect(() => {
   // if(fo)
   setFilterFormData({...filterFormData,search_type:1})
   console.log(filterFormData.search_type,"filterFormData.search_type");
   
   if(filterFormData?.search_type===1 || filterFormData?.search_type===undefined){
    fetchPurchaseOrderList()
   }
  }, []);

  const clearFilter = () => {
    setFilterFormData({});
    // setFilters({});
    fetchPurchaseOrderList();
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  } 

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
    isFilterRequired= {true}
      isButtonRequired={false}
      headerTopText="Logistics / Orders"
      headerTitle="Orders"
      listTitle="Order Received Request List"
      topDetailsList={topDataList}
      totalPages={totalPages}
      totalRecords={totalRecords}
      currentPage={currentPage}
      tableData={OrderRequestReceivedData}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleViewButton={handleViewDetails}
      filterInputs={filtersInputs}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      filterFormData={filterFormData}
      setFilterFormData={setFilterFormData}
      handleFormSubmit={handleSearch}
      handleClear={clearFilter}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleSearchChange={handleSearchChange}
      handleKeyPress={handleKeyPress} 
      apiCallFunction={apiCallFunction}
      searchplaceholder="Search by PO Type"
    />
      </div>
    )}
    </div>
  );
};

export default OrderReceivedRequest;
